$(document).one('turbo:load', function () {
	if (window.commonGlobalInitialized) return;
	window.commonGlobalInitialized = true;
	// close modal
	$(document).on('click', '.close-modal-btn', function (event) {
		event.preventDefault();
		$(event.target).closest($('.modal')).hide();
		// $('body').removeClass('modal-open');
	});

	// Adds scrolling effect to anchor links.
	$(document).on('click', '.anchor-link', function (event) {
		event.preventDefault();
		target = $(event.target);

		if (!target.hasClass('.anchor-link')) {
			target = target.closest('.anchor-link');
		}

		document.querySelector(target.attr('href')).scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	});

	// trigger modals smartly
	$(document).on('click', '.modal-trigger', function (event) {
		event.preventDefault();
		$('body').addClass('modal-open');
		$($(this).attr('data-target')).show();
	});

	// Turns all checkbox into custom checkbox
	$('input.checkbox.checkmark[type="checkbox"]').wrap($('<label class="checkbox-parent"></label>'));
	$('input.checkbox.checkmark[type="checkbox"]').after($('<span class="checkmark m-0"></span>'));

	// Detect and manipulation of 'Select all' for tables
	$('input.checkbox.checkmark[type="checkbox"]').change(function (event) {
		let allChildCheckboxes = $(this).closest($('table')).find($('input[type="checkbox"]')).not($('.select-all'));
		if ($(this).hasClass('select-all')) {
			if (this.checked) {
				allChildCheckboxes.prop('checked', true);
			} else {
				allChildCheckboxes.prop('checked', false);
			}
		} else {
			let trueCount = 0

			for (i = 0; i < allChildCheckboxes.length; i++) {
				if ($(allChildCheckboxes[i]).prop('checked')) {
					trueCount += 1
				}
			}

			if (trueCount === allChildCheckboxes.length) {
				$(this).closest($('table')).find($('.select-all')).prop('checked', true);
			} else {
				$(this).closest($('table')).find($('.select-all')).prop('checked', false);
			}

			event.stopPropagation();
		}
	});
});

// Tooltip function which scales and fits to the window.
function initializePopper(popper_dom, maxWidth = 300) {
	var element = $(popper_dom);
	element.prepend($('<div class="popper-arrow"></div>'));
	$('body').append(element);

	if (element.hasClass('popper-t')) {
		placement = 'top';
		behavior = ['top', 'bottom'];
	} else if (element.hasClass('popper-b')) {
		placement = 'bottom';
		behavior = ['top', 'bottom'];
	} else if (element.hasClass('popper-l')) {
		placement = 'left';
		behavior = ['left', 'right'];
	} else if (element.hasClass('popper-r')) {
		placement = 'right';
		behavior = ['left', 'right'];
	}

	let popper = new Popper($(element.attr('data-target')), element, {
		placement: placement,
		modifiers: {
			flip: { behavior: behavior },
			arrow: { element: '.popper-arrow' }
		}
	});

	element.find('.close-popper').click(function () {
		$(this).closest($('.popper')).remove();
	});

	element.css('maxWidth', maxWidth + 'px');
}

$(document).keydown(function (event) {
	if (event.keyCode == 27) {
		$('body').removeClass('modal-open');
		$('.more-action-button-child.duplicated').remove();
		$('.lightbox').hide();
		$('.modal').hide();
		$('.remove-on-escape').remove();
		$('.hide-on-escape').hide();
	}
});

// trigger bookings modal
$(document).on('click', '.trigger-bookings-modal', function (event) {
	mentor_id = $(event.target).attr('data-mentor-id');
	group_id = $(event.target).attr('data-group-id');
	org_id = $(event.target).attr('data-organization-id');
	program_id = $(event.target).attr('data-program-id');

	if ($('#new_bookings_modal').attr('data-mentor-id') != mentor_id || $('#new_bookings_modal').attr('data-group-id') != group_id) {
		$.ajax({
			method: 'GET',
			async: false,
			url: '/bookings/new_booking_modal',
			data: { mentor_id: mentor_id, group_id: group_id, org_id: org_id, program_id: program_id },
			success: function (response) {
				$('#booking-modal-content-holder').html(response);
				$('#new_bookings_modal').attr('data-mentor-id', mentor_id);
				$('#new_bookings_modal').attr('data-group-id', group_id);
			}
		});
	}
});

function validateEmail(email) {
	let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return emailRegex.test(email);
}

function sanitizeXss(str) {
	str = str.replace(/(<script>|<\/script>)/g, '');
	return str.trim();
}

window.initializePopper = initializePopper;
window.validateEmail = validateEmail;
window.sanitizeXss = sanitizeXss;